module.exports = __webpack_public_path__ + "static/media/cruise_ship.c424edae.jpeg";